import { jsxs, jsx } from "react/jsx-runtime";
const IconCogSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "m17.767 7.958-1.575-.525.742-1.483a.834.834 0 0 0-.159-.95L15 3.225a.833.833 0 0 0-.958-.158l-1.483.741-.525-1.575a.834.834 0 0 0-.784-.566h-2.5a.833.833 0 0 0-.791.566l-.525 1.575-1.484-.741a.833.833 0 0 0-.95.158L3.225 5a.833.833 0 0 0-.158.958l.742 1.484-1.575.525a.833.833 0 0 0-.567.783v2.5a.833.833 0 0 0 .567.792l1.575.525-.742 1.483a.833.833 0 0 0 .158.95L5 16.775a.834.834 0 0 0 .959.158l1.483-.741.525 1.575a.833.833 0 0 0 .792.566h2.5a.833.833 0 0 0 .791-.566l.525-1.575 1.484.741a.833.833 0 0 0 .941-.158L16.775 15a.833.833 0 0 0 .159-.958l-.742-1.484 1.575-.525a.833.833 0 0 0 .567-.783v-2.5a.834.834 0 0 0-.567-.792Zm-1.1 2.692-1 .333a1.666 1.666 0 0 0-.967 2.35l.475.95-.916.917-.925-.5a1.666 1.666 0 0 0-2.325.967l-.334 1H9.35l-.333-1a1.666 1.666 0 0 0-2.35-.967l-.95.475-.917-.917.5-.925a1.666 1.666 0 0 0-.966-2.35l-1-.333v-1.3l1-.333a1.667 1.667 0 0 0 .966-2.35l-.475-.925.917-.917.925.475a1.667 1.667 0 0 0 2.35-.967l.333-1h1.3l.334 1a1.668 1.668 0 0 0 2.35.967l.95-.475.916.917-.5.925a1.667 1.667 0 0 0 .967 2.325l1 .333v1.325ZM10 6.667a3.333 3.333 0 1 0 0 6.666 3.333 3.333 0 0 0 0-6.666Zm0 5a1.667 1.667 0 1 1 0-3.334 1.667 1.667 0 0 1 0 3.334Z" })
    ]
  }
);
export {
  IconCogSvg
};
